// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ol-tooltip {
  position: fixed;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  padding: 10px;
  z-index: 1000;
  cursor: auto;
  min-width: 165px !important;
  margin-top: 5px;
}
.ol-body {
  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif !important;
}
.ol-title {
  font-family: Karla, Roboto Condensed, Helvetica, Arial, sans-serif !important;
  font-weight: bold !important;
}
.ol-tooltip-text {
  margin: 0 0 6px;
  white-space: normal;
  font-size: 12px;
  line-height: 16px;
  color: #666666;
}
.ol-close-text {
  padding: 20px;
  margin: -20px;
  float: right;
  cursor: pointer;
}

.ol-tooltip-text-body {
  margin-top: 10px;
}


.ol-inline {
  display: inline;
}


@media (min-width: 996px) {
  .ol-close-text {
      display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/cta/css/tooltip.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,6EAA6E;EAC7E,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE;MACI,aAAa;EACjB;AACF","sourcesContent":[".ol-tooltip {\n  position: fixed;\n  background: #FFFFFF;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 3px;\n  padding: 10px;\n  z-index: 1000;\n  cursor: auto;\n  min-width: 165px !important;\n  margin-top: 5px;\n}\n.ol-body {\n  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif !important;\n}\n.ol-title {\n  font-family: Karla, Roboto Condensed, Helvetica, Arial, sans-serif !important;\n  font-weight: bold !important;\n}\n.ol-tooltip-text {\n  margin: 0 0 6px;\n  white-space: normal;\n  font-size: 12px;\n  line-height: 16px;\n  color: #666666;\n}\n.ol-close-text {\n  padding: 20px;\n  margin: -20px;\n  float: right;\n  cursor: pointer;\n}\n\n.ol-tooltip-text-body {\n  margin-top: 10px;\n}\n\n\n.ol-inline {\n  display: inline;\n}\n\n\n@media (min-width: 996px) {\n  .ol-close-text {\n      display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
